import { ContentGetQueryResponse } from '@app/modules/content-ai/content-ai.types';

export function isSocialOperationInProgress(data: ContentGetQueryResponse) {
  if (!data) {
    return false;
  }

  return Boolean(data.socialVersions.versions.find((v) => v.generation.status === 'IN_PROGRESS'));
}
